export class NumericOperationManager {
  static getSum(args: string[]): string {
    let sum: number = 0;
    let maxCifreDopoLaVirgola: number = 0;
    for (let arg of args) {
      if (!arg) {
        arg = '0';
      }
      arg = arg.toString().trim();
      if (arg.length >= 2 && arg.substring(0, 2) == '--') {
        arg = arg.substring(2);
      }
      arg = arg.replace(',', '.');
      let primaRimozioneMeno: boolean = false;
      if (arg.length >= 1 && arg.substring(0, 1) == '-') {
        arg = arg.substring(1);
        primaRimozioneMeno = true;
      }
      if (isNaN(+(arg))) {
        return '0';
      } else {
        let indicePuntoPrimo: number = arg.indexOf('.');
        if (indicePuntoPrimo >= 0) {
          let numberDopoVirgola: number = +(arg.substring(indicePuntoPrimo + 1));
          if (numberDopoVirgola == 0) {
            arg = arg.substring(0, indicePuntoPrimo);
          }
        }
        if (primaRimozioneMeno) {
          arg = '-' + arg;
        }
        let argValue: number = undefined;
        let cifreDopoLaVirgola: number = Math.max(sum.toString().trim().indexOf('.') === -1 ? 0 : sum.toString().trim().length - (sum.toString().trim().indexOf('.') + 1),
          arg.trim().indexOf('.') === -1 ? 0 : arg.trim().length - (arg.trim().indexOf('.') + 1));
        maxCifreDopoLaVirgola = Math.max(maxCifreDopoLaVirgola, cifreDopoLaVirgola);
        if (cifreDopoLaVirgola > 0) {
          let indexVirgolaSum: number = sum.toString().trim().indexOf('.') === -1 ? sum.toString().trim().length : sum.toString().trim().indexOf('.');
          let stringSum = sum.toString().trim().replace('.', '');
          while (stringSum.length < indexVirgolaSum + cifreDopoLaVirgola) {
            stringSum = stringSum + '0';
          }

          sum = +stringSum;

          let indexVirgolaArg: number = arg.trim().indexOf('.') === -1 ? arg.trim().length : arg.trim().indexOf('.');
          let stringArg = arg.trim().replace('.', '');
          while (stringArg.length < indexVirgolaArg + cifreDopoLaVirgola) {
            stringArg = stringArg + '0';
          }
          let argValue = +stringArg;
          sum = argValue + sum;
        } else {
          sum = sum + (+arg);
        }
        if (cifreDopoLaVirgola > 0) {
          let sumString: string = sum.toString().trim();
          let menoRemoved: boolean = false;
          if (sum < 0) {
            sumString = sumString.substring(1);
            menoRemoved = true;
          }
          if (sumString.length - cifreDopoLaVirgola < 1) {
            let initialValue: number = sumString.length - cifreDopoLaVirgola;
            while (initialValue < 1) {
              sumString = '0' + sumString;
              initialValue++;
            }
            sum = +((menoRemoved ? '-' : '') + '0.' + sumString.substring(1));
          } else {
            sum = +((menoRemoved ? '-' : '') + sumString.substring(0, sumString.length - cifreDopoLaVirgola) + '.' + sumString.substring(sumString.length - cifreDopoLaVirgola));
          }
        }

      }
    }
    if (maxCifreDopoLaVirgola > 2) {
      let indexVirgola: number = sum.toString().trim().indexOf('.');
      let sumString = sum.toString().trim().replace('.', '');
      sum = Math.round(+(sumString.substring(0, (indexVirgola + 2)) + '.' + sumString.substring(indexVirgola + 2)));
      sumString = sum.toString().trim();
      let menoTolto: boolean = false;
      if (sum < 0) {
        sumString = sumString.substring(1);
        sum = +(sumString);
        menoTolto = true;
      }
      if (sum < 100) {
        while (sumString.length < 3) {
          sumString = '0' + sumString;
        }
        sum = +((menoTolto ? '-' : '') + '0.' + sumString.substring(1));
      } else {
        sum = +((menoTolto ? '-' : '') + sumString.substring(0, sumString.length - 2) + '.' + sumString.substring(sumString.length - 2));
      }
    }
    let returnValue = sum.toFixed(2);
    return returnValue.toString().trim().replace('.', ',');
  }

  static getPercentuale(importo: string, percentuale: number): string {
    if (!importo) {
      return '0';
    }
    if (!percentuale) {
      return '0';
    }
    let importoStringNumber: string = importo.toString().trim().replace(',', '.');
    let menoTolto: boolean = false;
    if (importoStringNumber.length > 1 && importoStringNumber.substring(0, 1) == '-') {
      importoStringNumber = importoStringNumber.substring(1);
      menoTolto = true;
    }
    if (isNaN(+(importoStringNumber)) || isNaN(percentuale)) {
      return '0';
    }
    if (menoTolto) {
      importoStringNumber = '-' + importoStringNumber;
    }

    let percentualeString = percentuale.toString().trim();
    let cifreDopoLaVirgolaPercentuale: number = percentualeString.indexOf('.') === -1 ? 0 : percentualeString.length - (percentualeString.indexOf('.') + 1);
    if (cifreDopoLaVirgolaPercentuale > 2) {
      percentualeString = percentualeString.substring(0, percentualeString.indexOf('.') + 3);
      cifreDopoLaVirgolaPercentuale = 2;
    }

    percentualeString = percentualeString.replace('.', '');
    menoTolto = false;
    if (importoStringNumber.length > 1 && importoStringNumber.substring(0, 1) == '-') {
      importoStringNumber = importoStringNumber.substring(1);
      menoTolto = true;
    }
    let indiceFinale = (importoStringNumber.indexOf('.') === -1 ? importoStringNumber.length : importoStringNumber.indexOf('.')) - 2;
    importoStringNumber = importoStringNumber.replace('.', '');
    if (indiceFinale < 1) {
      while (indiceFinale < 1) {
        importoStringNumber = '0' + importoStringNumber;
        indiceFinale++;
      }
      importoStringNumber = (menoTolto ? '-' : '') + '0.' + importoStringNumber.substring(1);
    } else {
      importoStringNumber = (menoTolto ? '-' : '') + importoStringNumber.substring(0, indiceFinale) + '.' + importoStringNumber.substring(indiceFinale);
    }
    let arrayForSum: string[] = [];
    for (let index: number = 0; index < +percentualeString; index++) {
      arrayForSum.push(importoStringNumber);
    }
    importoStringNumber = NumericOperationManager.getSum(arrayForSum);
    if (cifreDopoLaVirgolaPercentuale > 0) {
      menoTolto = false;
      if (importoStringNumber.length > 1 && importoStringNumber.substring(0, 1) == '-') {
        importoStringNumber = importoStringNumber.substring(1);
        menoTolto = true;
      }
      indiceFinale = (importoStringNumber.indexOf(',') === -1 ? importoStringNumber.length : importoStringNumber.indexOf(',')) - cifreDopoLaVirgolaPercentuale;
      importoStringNumber = importoStringNumber.replace(',', '');
      if (indiceFinale < 1) {
        while (indiceFinale < 1) {
          importoStringNumber = '0' + importoStringNumber;
          indiceFinale++;
        }
        importoStringNumber = (menoTolto ? '-' : '') + '0,' + importoStringNumber.substring(1);
      } else {
        importoStringNumber = (menoTolto ? '-' : '') + importoStringNumber.substring(0, indiceFinale) + ',' + importoStringNumber.substring(indiceFinale);
      }
      importoStringNumber = NumericOperationManager.getSum([importoStringNumber, '0']);
    }
    return importoStringNumber;
  }

  static getDiff(a: string, b: string) {
    if (!a) {
      a = '0';
    } else {
      a = String(a);
      a = a.replace(',', '.');
    }
    if (!b) {
      b = '0';
    } else {
      b = String(b);
      b = b.replace(',', '.');
    }
    let returnValue = (Number(a) - Number(b));
    return NumericOperationManager.getSum([String(returnValue), '0']);
  }

  static stringToNumber(value: string): string {
    value = value.toString().split('.').join('').replace(',', '.');
    return value;
  }

  static numberToString(value: string): string {
    let valueToReplace = '' + value;
    value = valueToReplace.replace('.', ',');
    return value;
  }


  static transformToThousands(value: string) {

    let isNegative = false;
    if (value.charAt(0) === '-') {
      isNegative = true;
      value = value.substring(1);
    }

    let result = '';
    if (value && value.length > 1) { // rimuove gli zeri iniziali
      while (value.charAt(0) === '0') {
       value = value.substr(1);
      }
    }
    if (value.toString().indexOf(',') === -1) {
      value = value + ',00';
    }
    let arrayString: string[] = value.split(',');
    let primaDellaVirgola = arrayString[0];
    if (primaDellaVirgola) {
      primaDellaVirgola = primaDellaVirgola.toString().replace('.', '');
    }
    let temp = '';
    for (let i = 1; i < primaDellaVirgola.length + 1; i++) {
      temp = primaDellaVirgola[primaDellaVirgola.length - i] + temp;
      if (i % 3 === 0 && (i !== primaDellaVirgola.length)) {
        temp = '.' + temp;
      }
    }
    if (!temp || (temp && temp.trim().length === 0)) {
      temp = '0';
    }
    if (arrayString[1] && arrayString[1].trim().length > 0) {
      if (arrayString[1].trim().length === 1) {
        result = temp + ',' + arrayString[1].trim() + '0';
      } else {
        result = temp + ',' + arrayString[1].trim();
      }
    } else {
      result = temp + ',00';
    }

    if (isNegative) {
      result = '-' + result;
    }

    return result;
  }
}

